var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "profile-field__title",
          class: {
            "profile-field__title--required": _vm.field.required,
          },
        },
        [_vm._v(" Портфолио ")]
      ),
      _vm.links.length
        ? _c(
            "transition-group",
            { staticClass: "links", attrs: { tag: "div", name: "fade" } },
            _vm._l(_vm.links, function (link, i) {
              return _c(
                "div",
                { key: link.id, staticClass: "link" },
                [
                  _c("c-input", {
                    staticClass: "text",
                    attrs: {
                      "floating-label": "Ссылка на портфолио",
                      clearable: "",
                      required:
                        _vm.error && _vm.error.links && _vm.error.links[i],
                      "required-message":
                        _vm.error && _vm.error.links && _vm.error.links[i],
                    },
                    model: {
                      value: link.link,
                      callback: function ($$v) {
                        _vm.$set(link, "link", $$v)
                      },
                      expression: "link.link",
                    },
                  }),
                  _c("c-button", {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.html",
                        value: {
                          container: "#app",
                          trigger: "hover blur",
                          content: "Удалить",
                          placement: "top",
                        },
                        expression:
                          "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                        modifiers: { html: true },
                      },
                    ],
                    staticClass: "remove",
                    attrs: {
                      size: "iconic",
                      icon: { icon: "trash", color: "secondary" },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.removeLink(link)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm.preview
        ? _c("div", { staticClass: "preview" }, [
            _c(
              "div",
              { staticClass: "file-preview" },
              [
                _c("file-preview", {
                  attrs: {
                    type: "doc",
                    name: "Документ 1.docx",
                    "data-type": "link",
                  },
                }),
                _c("c-button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover blur",
                        content: "Удалить",
                        placement: "top",
                      },
                      expression:
                        "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                      modifiers: { html: true },
                    },
                  ],
                  staticClass: "file-preview__remove",
                  attrs: { disabled: true, size: "iconic", icon: "trash" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("c-button", {
            staticClass: "add-link",
            attrs: {
              icon: { icon: "plus", color: "primary" },
              label: "Добавить ссылку",
              disabled: _vm.preview || _vm.hasEmptyLinks,
              size: "small",
            },
            on: { click: _vm.addLink },
          }),
          !_vm.files.length && !_vm.fileLinks.length
            ? _c("c-button", {
                staticClass: "add-file",
                attrs: {
                  icon: { icon: "plus", color: "primary" },
                  label: "Добавить файл",
                  disabled: _vm.preview,
                  size: "small",
                },
                on: { click: _vm.addFile },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("file-loader", {
        ref: "loader",
        staticClass: "files",
        style: {
          display: _vm.files.length || _vm.fileLinks.length ? "" : "none",
        },
        attrs: {
          links: _vm.fileLinks,
          format: "images,pdf,docs",
          actions: "loadFiles,preview",
          limit: _vm.field.maxFiles || 10,
          disabled: _vm.preview,
        },
        on: { changeLinks: _vm.updateFileLinks },
        model: {
          value: _vm.files,
          callback: function ($$v) {
            _vm.files = $$v
          },
          expression: "files",
        },
      }),
      _vm.error && _vm.error.common
        ? _c("error-feedback", {
            attrs: { text: _vm.error && _vm.error.common },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }